module.exports = __webpack_public_path__ + "img/ken2.40570b54.jpg";